import { AdditionalDetailsData, PaymentData } from "@adyen/adyen-web";

export async function SessionsSetupCall({
  locale,
  countryCode,
  amount,
  store,
}: any) {
  try {
    const shopperEmail = localStorage.getItem("shopperEmail");
    const paymentRequest = {
      amount: amount,
      countryCode: countryCode,
      shopperLocale: locale,
      blockedPaymentMethods: ["wechatpayWeb"],
      channel: "Web",
      lineItems: [],
      reference: store,
      returnUrl: process.env.REACT_APP_RETURN_URL,
      shopperEmail: shopperEmail,
    };

    const response: any = await GetSessions(paymentRequest);
    if (response) {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error("Error during sessions setup call", error);
  }
}

async function GetSessions(body: any): Promise<any> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SITE}api/adyen-session`,
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );

    const session = await response;
    return session;
  } catch (error) {
    console.error(`Erreur dans sessions setup  ${error}`);
    return new Response(JSON.stringify({ error: "Internal Server Error" }), {
      status: 500,
    });
  }
}

async function paymentMethodsCall({
  lang,
  countryCode,
  amount,
  shopperReference,
}: any) {
  try {
    const paymentMethodsConfig = {
      countryCode,
      amount,
      channel: "Web",
      store: shopperReference,
    };

    const response: any = await paymentMethods(paymentMethodsConfig);

    if (response) {
      const { paymentMethodsResponse } = await response.json();
      return paymentMethodsResponse;
    }
  } catch (error) {
    console.log(error);
  }
}

export default paymentMethodsCall;

async function paymentMethods(fullRequest: any) {
  const response = await fetch(
    `${process.env.REACT_APP_SITE}api/adyen/paymentMethods`,
    {
      method: "POST",
      body: JSON.stringify(fullRequest),
      // @ts-ignore
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const paymentMethodsResponse = await response.json();
  return { paymentMethodsResponse };
}

export async function paymentsCall(
  data: PaymentData,
  countryCode: any,
  shopperLocale: any,
  amount: any,
  shopperReference: any
) {
  const paymentsRequest = {
    ...data,
    countryCode,
    shopperLocale,
    amount,
    store: shopperReference,
    channel: "Web",
  };

  try {
    const response = await payment(JSON.stringify(paymentsRequest));

    if (response) {
      return response;
    }
  } catch (error) {
    console.error("Error during /payments call", error);
  }
}

async function payment(body: any) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SITE}api/adyen/payments`,
      {
        method: "POST",
        body: body,
        // @ts-ignore
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error(`Erreur dans payment  ${error}`);
  }
}

export async function paymentDetailsCall(data: AdditionalDetailsData["data"]) {
  try {
    const response = await getpaymentDetails(JSON.stringify(data));

    if (response) {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getpaymentDetails(body: any) {
  try {
    const fullRequest = {
      ...body,
    };

    const response = await fetch(
      `${process.env.REACT_APP_SITE}api/adyen/details`,
      {
        method: "POST",
        body: JSON.stringify(fullRequest),
        // @ts-ignore
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(
      `Erreur lors de la tentative de paiement avec Adyen. Détails de l'erreur : ${error}`
    );
  }
}
